import React from "react";
import EnergoTabElem from "./EnergoTabElem";


const EnergoTab = ({data, setData}) => {

    const clickHandler = (id) => {
        const updatedTabs = data.map((tab) => 
            tab.id === id ?
            {...tab, selected: !tab.selected} : {...tab}
        );
        setData(updatedTabs);
    }

    return (
        <div
            style={{
                border: "1px solid #ced4da",
                borderRadius: 24,
                padding: 0,
                fontSize: 18,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                overflow: "hidden",
                height: 50,
                cursor: "pointer",
        }}>
            {data.map(item => (
                <EnergoTabElem key={item.id} item={item} clickHandler={clickHandler} />
            ))}
        </div>
    )
}

export default EnergoTab;